export default "__VITE_ASSET__cb2e3b47__"